import { render, staticRenderFns } from "./DeptView.vue?vue&type=template&id=5d4c46a7&scoped=true"
import script from "./DeptView.vue?vue&type=script&lang=js"
export * from "./DeptView.vue?vue&type=script&lang=js"
import style0 from "./DeptView.vue?vue&type=style&index=0&id=5d4c46a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c46a7",
  null
  
)

export default component.exports